import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@guildeducationinc/recess';
import { useMemo } from 'react';
import { useLocale } from '../../hooks/useLocale';
import { DropdownSelect } from '../DropdownSelect';
/**
 * A component that renders a dropdown select input for selecting values from an enum.
 * @param props - The component props.
 * @returns The rendered EnumPicker component.
 */
export function EnumPicker(props) {
    const { t } = useLocale();
    const options = useMemo(() => {
        return Object.entries(props.enumType).map(([, value]) => ({
            value,
            label: props.labelPrefix ? t(`${props.labelPrefix}.${value}`) : String(value),
        }));
    }, [props.enumType, props.labelPrefix, t]);
    const placeholder = props.placeholderKey
        ? t(props.placeholderKey, { defaultMessage: 'Select' })
        : '';
    if (props.useMui) {
        return (_jsx(DropdownSelect, { label: props.label ?? placeholder ?? '', hideLabel: props.hideLabel, value: props.value, onChange: value => props.onChange(value.target.value ?? ''), options: options, className: props.className, btnStyle: props.btnStyle, disabled: props.disabled, color: typeof props.useMui === 'boolean' ? 'secondary' : props.useMui, isClearable: props.isClearable, errors: props.errors }));
    }
    return (_jsx(Select, { easyPortal: true, isClearable: props.isClearable ?? true, label: props.label ?? '', options: options, hideLabel: props.hideLabel, placeholder: placeholder, value: props.value, onChange: value => props.onChange(value.target.value ?? ''), className: props.className, disabled: props.disabled, isSearchable: props.isSearchable, errors: props.errors }));
}
